import {createStrokeSVG} from './TEMPLATE'

// tabler: trending-up
export const Growth_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M3 17l6 -6l4 4l8 -8', 'M14 7l7 0l0 7'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
